/* eslint-disable react-hooks/exhaustive-deps */
import { useStrapiGlobal } from '@/context';
import classNames from 'classnames';
import { type ReactElement, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import CTNInput from '@ctn/ui/components/ctn-input';
import CTNIcon from '@ctn/ui/components/ctn-icon/icon';
import CTNButton from '@ctn/ui/components/ctn-button';
import { useForm } from 'react-hook-form';
import type { NavItem } from '@/interfaces/strapi';
import { MenuTree } from '@/components';

type HeaderProps = {
	readonly className?: string;
};

const classNameComponent = 'c-cnm-header';

export const HeaderConferencias = ({ className }: HeaderProps): ReactElement => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [classNameComponent, className]);
	const { layout } = useStrapiGlobal();
	const { header } = layout;
	const { logo } = header;

	const [isMobileOpen, setIsMobileOpen] = useState(false);

	useEffect(() => {
		const onKeydown = (e: KeyboardEvent) => {
			if (e.key === 'Escape') setIsMobileOpen(false);
		};
		document.addEventListener('keydown', onKeydown);

		document.body.classList.toggle('no-scroll', isMobileOpen);

		return () => {
			document.removeEventListener('keydown', onKeydown);
			document.body.classList.remove('no-scroll');
		};
	}, [isMobileOpen]);

	return (
		<header className={wrapperClassName}>
			{/* --- Logo Absoluto (Desktop) --- */}
			<Link to="/academia-matritense/hemeroteca" className={`${wrapperClassName}__logo`}>
				<img className={`${wrapperClassName}__logo-img`} src={logo.imageUrl} alt={logo.alt} />
			</Link>

			{/* --- Fila 1 (MÓVIL): brandbar con fondo de logo a 100% --- */}
			<div className={`${wrapperClassName}__row ${wrapperClassName}__brandbar`}>
				<div className={`${wrapperClassName}__container`}>
					<Link
						to="/academia-matritense/hemeroteca"
						className={`${wrapperClassName}__brandlogo`}
						aria-label="Inicio"
					>
						<img className={`${wrapperClassName}__brandlogo-img`} src={logo.imageUrl} alt={logo.alt} />
					</Link>
				</div>
			</div>

			{/* --- Fila 2: topbar (título + iconos en móvil | buscador+botón en desktop) --- */}
			<div className={`${wrapperClassName}__row ${wrapperClassName}__topbar`}>
				<div className={`${wrapperClassName}__container`}>
					<span className={`${wrapperClassName}__title`}>COLEGIO NOTARIAL DE MADRID</span>

					<div className={`${wrapperClassName}__right`}>
						{/* Form buscador (DESKTOP) */}
						<Link to="https://intranet-madrid.notariado.org/intranet-cnm" target="_blank">
							<CTNButton
								type="button"
								variant="solid"
								mode="primary"
								className={`${wrapperClassName}__btn`}
								icon={[{ icon: 'login', position: 'left', color: 'primary-white' }]}
								label="Acceder"
							/>
						</Link>
					</div>
				</div>
			</div>

			{/* --- Fila 3 (MÓVIL): menubar compacta con “Inicio” + burger --- */}
			{/* <div className={`${wrapperClassName}__row ${wrapperClassName}__menubar ${isMobileOpen ? 'is-open' : ''}`}>
				<div className={`${wrapperClassName}__container`}>
					<CTNIcon
						icon={isMobileOpen ? 'close' : 'hamburger'}
						className={`${wrapperClassName}__burger`}
						aria-expanded={isMobileOpen}
						aria-controls={`${wrapperClassName}__mobilemenu`}
						onClick={() => setIsMobileOpen((v) => !v)}
					/>
				</div>
			</div> */}

			{/* --- Menú completo (DESKTOP) --- */}
			<div className={`${wrapperClassName}__row ${wrapperClassName}__middle`}>
				<div className={`${wrapperClassName}__container ${wrapperClassName}__titleRow`}>
					<span>Conferencias de la Academia Matritense del Notariado</span>
				</div>
			</div>

			{/* Drawer + Backdrop (móvil/tablet) */}
			{isMobileOpen && (
				<div
					className={`${wrapperClassName}__backdrop`}
					aria-hidden="true"
					onClick={() => setIsMobileOpen(false)}
				/>
			)}

			<div className={`${wrapperClassName}__row ${wrapperClassName}__mottobar`}>
				<div className={`${wrapperClassName}__container ${wrapperClassName}__motto-grid`}>
					<h3 className={`${wrapperClassName}__slogan`}>
						N<span>IHIL</span> P<span>RIUS</span> F<span>IDE</span>
					</h3>
				</div>
			</div>
		</header>
	);
};
